module.exports = __webpack_public_path__ + "static/media/go-by-bike.1a61105a.jpeg";